const translations = {
  'sv-SE': {
    'Payment terms': 'Avbetalningskalkyl',
    'Acquisition price excl. VAT:': 'Anskaffningspris ex. moms:',
    'Trade-in excl. VAT:': 'Inbyte ex. moms:',
    'Down payment:': 'Kontantinsats:',
    'Credit amount (inc. VAT):': 'Kreditbelopp (inkl. moms):',
    'Interest:': 'Ränta:',
    'Term:': 'Löptid:',
    'Periodicity:': 'Periodicitet:',
    'Month payment': 'Månadsbetalning',
    'Quarter payment': 'Kvartalsbetalning',
    'Months': 'Månader',
    'Quarters': 'Kvartal',
    'Period expense': 'Periodkostnad',
    'Amortization amount:': 'Amorteringsbelopp:',
      'Payment month 1 inc interest:': 'Första betalning inkl. ränta:',
    'Increased amortization month 3 / 1:st quarter:': 'Höjd amortering månad 3 / 1:a kvartalet:',
    'Setup fee:': 'Ev. uppläggningsavgift:',
    'Administration fee:': 'Ev. aviavgift:',
    '(Interest is added)': '(Ränta tillkommer)',
    'Financing in cooperation with Nordea Finans': 'Finansiering i samarbete med Nordea Finans',
    'inc. VAT': 'ink. moms',
    '@cooperationName in cooperation with Nordea Finans': '@cooperationName i samarbete med Nordea Finans',
    '(refers to the amount of VAT / one-time collection)': '(avser momsbeloppet, engångsamortering)',
    'Payment plan': 'Betalplan',
    'Repayment period:': 'Amorteringstid:',
  },
};

function doReplacements(str, replacements) {
  let replaced = str;
  if (replacements) {
    Object.keys(replacements).forEach(k => {
      replaced = replaced.replace(k, replacements[k])
    });
  }
  return replaced;
}

export function createTranslator(locale = 'sv-SE') {
  return function translate(str, replacements) {
    if (!locale || !translations[locale]) {
      return doReplacements(str, replacements);
    }
    return doReplacements(translations[locale][str] || str, replacements);
  }
}
